import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getEventByIdAdmin } from "../../api/plan";
// import { getTicketsByEventId, deleteTicketById } from "../../api/ticket";
import TicketTable from "./TicketTable";
import DashboardLayout from "./components/Layout";
import useRole from "./components/useRole";
import { deleteTicket } from "../../api/subscription";

const TicketsPage = () => {
  const { eventId: id } = useParams();
  const { role, isTicketControl, seesStats, canIssueTickets, canDeleteTickets, canEditTicket } = useRole(id);

  const [eventData, setEventData] = useState(null);
  const [ticketTypeFilter, setTicketTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("success");
  const [paidByFilter, setPaidByFilter] = useState("");

  useEffect(() => {
    // no role on this event means no business here, whatever they are elsewhere
    if (!role) {
      window.location.replace("/");
    }
  }, [role]);

  const fetchEventData = async (id) => {
    const response = await getEventByIdAdmin(id);
    setEventData(response?.data?.data);
  };

  useEffect(() => {
    if (id) {
      fetchEventData(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onDelete = async (eventId, ticketId) => {
    const confirmed = window.confirm("Bu bileti silmək istədiyinizə əminsiniz?");
    if (confirmed) {
      try {
        await deleteTicket(eventId, ticketId);
        fetchEventData(eventId); // Silmədən sonra siyahını yenilə
      } catch (error) {
        console.error("Bilet silinərkən xəta baş verdi:", error);
        alert("Silinmə zamanı xəta baş verdi.");
      }
    }
  };

  return (
    <DashboardLayout id={id}>
        {id && (
          <main className="flex-1 bg-gray-100">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">📄 Bilet Siyahısı</h2>
              {canIssueTickets && (
                <Link
                  to={`/dashboard/${id}/tickets/new`}
                  className="bg-gray-800 text-white px-5 py-2 rounded-md hover:bg-gray-700 transition"
                >
                  Yeni Bilet
                </Link>
              )}
            </div>

            {/* Ticket Table */}
            <TicketTable
              eventId={id}
              tickets={eventData?.tickets}
              canEdit={canEditTicket}
              canDelete={canDeleteTickets}
              canOpenTicket={!isTicketControl}
              showMoney={seesStats}
              onDelete={onDelete}
              ticketTypeFilter={ticketTypeFilter}
              setTicketTypeFilter={setTicketTypeFilter}
              statusFilter={statusFilter}
              paidByFilter={paidByFilter}
              setStatusFilter={setStatusFilter}
              setPaidByFilter={setPaidByFilter}
            />
		</main>)}
	</DashboardLayout>
  );
};

export default TicketsPage;
